import { ref } from 'vue';
import aiMessageVettingAgentsClient from '~/services/aiMessageVettingAgents/aiMessageVettingAgentsClient';
import { createGlobalState } from '@vueuse/core';

export const useAiMessageVettingAgentsMessageStandardCounts = createGlobalState(() => {
    // [agentId]: messageStandardCount
    // undefined = loading (key doesn't exist in the object yet)
    const messageStandardCounts = ref<Record<number, number>>({});

    const fetching = ref(false);

    const fetchMessageStandardCounts = async (teamId: number, agentIds: number[]) => {
        // remove existing ids to avoid computing them again
        agentIds = agentIds.filter((agentId) => !(agentId in messageStandardCounts.value));

        if (!agentIds.length) {
            return;
        }

        if (fetching.value) {
            // when its currently making a request call wait a bit before retrieving again
            setTimeout(() => {
                fetchMessageStandardCounts(teamId, agentIds);
            }, 500);
            return;
        }

        try {
            fetching.value = true;

            // API accepts max 10 agent IDs at a time, so batch requests
            const batchSize = 10;
            for (let i = 0; i < agentIds.length; i += batchSize) {
                const batch = agentIds.slice(i, i + batchSize);

                const response = await aiMessageVettingAgentsClient.getAiMessageVettingAgentMessageStandardCounts(
                    { teamId },
                    { ai_message_vetting_agent_ids: batch }
                );

                batch.forEach((agentId) => {
                    messageStandardCounts.value[agentId] = response.data.counts[agentId] ?? 0;
                });
            }
        } finally {
            fetching.value = false;
        }
    };

    const resetMessageStandardCounts = () => {
        messageStandardCounts.value = {};
        fetching.value = false;
    };

    return {
        fetchMessageStandardCounts,
        messageStandardCounts,
        resetMessageStandardCounts,
    };
});
